import ArraySnippetInterface from './array-snippet-interface';

class ArraySnippetPicker implements ArraySnippetInterface {
    constructor(private arraySnippets: ArraySnippetInterface[]) {}

    makeSnippet(content: string[][]): string[][] {
        const snippet: string[][] = [];

        this.arraySnippets.map((arraySnippet) => {
            snippet.push(...arraySnippet.makeSnippet(content));
        });

        return snippet;
    }
}

export default ArraySnippetPicker;
